import React, { useState, useContext, useEffect } from 'react';
import { ThemeContext } from 'context/themeContext';
import styled from 'styled-components';
import { getInvoiceProps } from 'containers/dashboard/container/api';
import { useTranslation } from 'react-i18next';

export const ShippingInformationText = styled.div`
  width: ${(props) => (props.width ? props.width : 'unset')};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '1.145vw')};
  font-weight: 500;
  color: ${(props) => props.color ?? props.theme.textPrimary};
`;

const ShippingInfoWrapper = styled.div`
margin-left:2vw;
`;

const Wrapper = styled.div`
  width: 25vw;
  border-radius: 4.164vw;
  background-color: ${(props) => (props.selected ? props.theme.pure : props.theme.cardBackground)};
  transition: 200ms linear;
  padding-bottom:1.56vw;
  padding-top:1.56vw;
  margin-right:${(props) => props.rtlDirection ? '2vw' : 'unset'};
  padding-left:${(props) => props.rtlDirection ? 'unset' : '1.7vw'};
  padding-right:${(props) => props.rtlDirection ? '1.7vw' : 'unset'};
`;

export const StyledLine = styled.div`
  width: 26.184vw;
  height: 1px;
  position: relative;
  margin-right:${(props) => props.rtlDirection ? "2vw" : "unset"};
  margin-top: 1.04vw;
  margin-bottom: 1.04vw;
  background-color: ${(props) => props.theme.cardBackground};
`;

export const StyledSubTitle = styled.div`
  width: 26.184vw;
  position: relative;
  font-size: 0.728vw;
  margin-bottom: 0.56vw;
  margin-right:${(props) => props.rtlDirection ? "2vw" : "unset"};
  color: ${(props) => props.theme.textSecondary};
`;

const ShippingInfo = (props) => {
    const { theme, rtlDirection } = useContext(ThemeContext);
    const { t } = useTranslation();
    const [shppingMethod, setShippingMethod] = useState();

    useEffect(() => {
        getInvoiceProps(props.invoiceId).then((result) => {
            setShippingMethod(result.invoice.shipping_name)
        })
    }, [props.invoiceId])
    return (
        <ShippingInfoWrapper>
            <StyledLine theme={theme} rtlDirection={rtlDirection} />
            <StyledSubTitle theme={theme} rtlDirection={rtlDirection}>{t('dashboard.order modal.Shipping information')}</StyledSubTitle>
            <Wrapper rtlDirection={rtlDirection} theme={theme}>
                <ShippingInformationText theme={theme} fontSize={"0.9vw"}>
                {t('dashboard.order modal.Shipping Method')}:{" "}{shppingMethod}
                </ShippingInformationText>
            </Wrapper>
            <Wrapper rtlDirection={rtlDirection} theme={theme} style={{ marginTop: "0.6vw" }}>
                <ShippingInformationText theme={theme} fontSize={"0.9vw"}>
                {t('dashboard.order modal.Tracking Number')}:{" "}{props.selectedOrder.post_id}
                </ShippingInformationText>
            </Wrapper>
        </ShippingInfoWrapper>
    )
}

export default ShippingInfo